import { Link } from 'react-router';
import { PageHead } from '../components/ui';

const TEXT: Record<string, { title: string; phase: string; body: string }> = {
  notfound: {
    title: 'Page not found',
    phase: '',
    body: 'There is no page at this address.',
  },
};

export function Placeholder({ module }: { module: keyof typeof TEXT }) {
  const t = TEXT[module];
  return (
    <div className="page narrow">
      <PageHead title={t.title} meta={t.phase} />
      <p className="lede">{t.body}</p>
      <p>
        <Link to="/">Back to the Overview</Link>
      </p>
    </div>
  );
}
